import { useMemo } from 'react'
import { visionData } from '../data/visionDataV2'
import { countryMapVision } from '../constants/visionCountryMap'
import {
	getVisionCountriesForCareer,
	resolveHomeCountryKey,
} from '../utils/visionCountryRanking'

const asNumber = value => {
	const n = Number(value)
	return Number.isFinite(n) ? n : Number.NEGATIVE_INFINITY
}

export function buildCareerVisionById({ professions = [], homeCountryKey = null } = {}) {
	const out = {}

	;(professions || []).forEach((profession, index) => {
		const professionId = profession?.profession_id
		if (!professionId) return

		const visionRow = visionData?.[professionId]
		const countriesByKey = visionRow?.countries
		if (!countriesByKey || typeof countriesByKey !== 'object') {
			out[professionId] = {
				withHomeCountry: false,
				topCountries: [],
				maxTopScore: Number.NEGATIVE_INFINITY,
				originalIndex: index,
			}
			return
		}

		const ordered = getVisionCountriesForCareer({ countriesByKey, homeCountryKey })
		const topCountries = ordered.slice(0, 3).map((item, rank) => ({
			...item,
			rank,
			displayCountry: countryMapVision[item.country] || item.country,
		}))

		const withHomeCountry = Boolean(
			homeCountryKey && topCountries[0]?.country === homeCountryKey,
		)
		const maxTopScore = topCountries.reduce(
			(acc, item) => Math.max(acc, asNumber(item?.score)),
			Number.NEGATIVE_INFINITY,
		)

		out[professionId] = {
			withHomeCountry,
			topCountries,
			maxTopScore,
			originalIndex: index,
		}
	})

	return out
}

export function useVisionCareerPriorities({ professions = [], profileBuilderData = null } = {}) {
	const homeCountryKey = useMemo(
		() => resolveHomeCountryKey({ profileBuilderData }),
		[profileBuilderData],
	)

	const careerVisionById = useMemo(
		() => buildCareerVisionById({ professions, homeCountryKey }),
		[homeCountryKey, professions],
	)

	return {
		homeCountryKey,
		careerVisionById,
	}
}
